'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$ByDocument(kind) {
  this.Xo = null;
  this.Xo = kind;
}
export { $c_Lpresto_CredentialsView$ByDocument as $c_Lpresto_CredentialsView$ByDocument };
$p = $c_Lpresto_CredentialsView$ByDocument.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$ByDocument;
/** @constructor */
function $h_Lpresto_CredentialsView$ByDocument() {
}
export { $h_Lpresto_CredentialsView$ByDocument as $h_Lpresto_CredentialsView$ByDocument };
$h_Lpresto_CredentialsView$ByDocument.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_CredentialsView$ByDocument)) {
    var x = this.Xo;
    var x$2 = x$0.Xo;
    return ((x === null) ? (x$2 === null) : x.i(x$2));
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "ByDocument";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Xo;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_CredentialsView$ByDocument(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hY)));
}
export { $isArrayOf_Lpresto_CredentialsView$ByDocument as $isArrayOf_Lpresto_CredentialsView$ByDocument };
var $d_Lpresto_CredentialsView$ByDocument = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$ByDocument, "presto.CredentialsView$ByDocument", ({
  hY: 1,
  e9: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_CredentialsView$ByDocument as $d_Lpresto_CredentialsView$ByDocument };
//# sourceMappingURL=presto.-Credentials-View$-By-Document.js.map
